<template>
  <div class="popup-backdrop" v-bind:class="{ hide : dynamicComponent === ''}">
    <component v-bind:is="dynamicComponent"></component>
  </div>
</template>

<script>
const UserNewPopup = () => import('@/components/popups/userNewPopup');
const UserGroupNewPopup = () => import('@/components/popups/userGroupNewPopup');
const UserNewInGroupPopup = () => import('@/components/popups/userNewInGroupPopup');
const UploadFilePopup = () => import('@/components/popups/uploadFilePopup');
const EventsEditPopup = () => import('@/components/popups/eventsEditPopup');
const DeletePopup = () => import('@/components/popups/deletePopup');
const AddImage = () => import('@/components/popups/addImagePopup');
const EditCategory = () => import('@/components/popups/editCategoryNamePopup');
const EditShop = () => import('@/components/popups/editShopPopup');
const ShopCategories = () => import('@/components/popups/addCategoriesPopup');
const EditService = () => import('@/components/popups/addNewServicePopup');
const EditOffer = () => import('@/components/popups/offerEditPopup');
const EditMall = () => import('@/components/popups/AddMallPopup');
const MallUsers = () => import('@/components/popups/AddUsersPopup');
const TextEditor = () => import('@/components/popups/editTextPopup');
const PreviewSlideShow = () => import('@/components/popups/previewSlidePopup');
const EditSlideShow = () => import('@/components/popups/editSlidePopup');
const CopyPopup = () => import('@/components/popups/copyPopup');
const StationPopup = () => import('@/components/popups/AddStationPopup');
const ChartView = () => import('@/components/popups/chartViewPopup');
const EditGarage = () => import('@/components/popups/addNewGaragePopup');
const EditFloor = () => import('@/components/popups/addFloorPopup');
const PreviewImageShow = () => import('@/components/popups/previewImagesPopup');
const addMediaCategory = () => import('../popups/addMediaCategoryPopup');

export default {
  name: "popup",
  components: {
    'user-new-popup': UserNewPopup,
    'edit-garage': EditGarage,
    'edit-floor': EditFloor,
    'chart-view': ChartView,
    'station-popup': StationPopup,
    'copy-popup': CopyPopup,
    'text-editor': TextEditor,
    'edit-slide-show': EditSlideShow,
    'preview-slide-show': PreviewSlideShow,
    'preview-image-show': PreviewImageShow,
    'mall-new-popup': EditMall,
    'mall-users-popup': MallUsers,
    'edit-category': EditCategory,
    'offers-edit-popup': EditOffer,
    'edit-service': EditService,
    'shop-categories-popup': ShopCategories,
    'edit-shop': EditShop,
    'add-image-popup': AddImage,
    'events-edit-popup': EventsEditPopup,
    'delete-popup': DeletePopup,
    'user-group-new-popup': UserGroupNewPopup,
    'newuser-ingroup-popup': UserNewInGroupPopup,
    'upload-file-popup': UploadFilePopup,
    'media-category-new': addMediaCategory
  },
  computed: {
    dynamicComponent() {
      return this.$store.state.popupViewName;
    }
  }
};
</script>
